import { render, staticRenderFns } from "./EssayEdit.vue?vue&type=template&id=054db35d&scoped=true&"
import script from "./EssayEdit.vue?vue&type=script&lang=js&"
export * from "./EssayEdit.vue?vue&type=script&lang=js&"
import style0 from "./EssayEdit.vue?vue&type=style&index=0&id=054db35d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054db35d",
  null
  
)

export default component.exports